import { InjectionToken } from '@angular/core';
import { AuthConfig } from './models';

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AUTH_CONFIG');
